'use client'

import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'
import { Fragment } from 'react'

const renderLabelWithSansTrademark = (label: string) => {
  const parts = label.split('™')

  return parts.map((part, index) => (
    <Fragment key={index}>
      {index < parts.length - 1 ? part.trimEnd() : part}
      {index < parts.length - 1 && <span className='font-sans'>™</span>}
    </Fragment>
  ))
}

export const RunSafeInTheDarkFounderSaidCta = ({
  collectionLabel,
  technologyLabel,
}: {
  collectionLabel: string
  technologyLabel: string
}) => {
  return (
    <div className='mt-6 flex items-center gap-4 max-md:flex-wrap'>
      <Button
        size='large'
        variant='primary'
        className='max-md:w-full'
        onClick={() => {
          document.getElementById('collection-listing')?.scrollIntoView({
            behavior: 'smooth',
          })
        }}
      >
        {collectionLabel}
        <ArrowRight className='size-5' />
      </Button>
      <Button
        size='large'
        variant='white'
        className='max-md:w-full'
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
      >
        <span>{renderLabelWithSansTrademark(technologyLabel)}</span>
        <ArrowRight className='size-5' />
      </Button>
    </div>
  )
}
